<template>

    <div :class="{ 'container': fluid === false }" class="mx-auto">
        <slot/>
    </div>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'Container',
        props: {
            fluid: {
                type: Boolean, default: false
            }
        }
    })

</script>

<style lang="scss">

    @include component(container) {

        padding-right: 30px;
        padding-left: 30px;

        @screen lg {

            padding-right: 40px;
            padding-left: 40px;

        }

        @screen xl {

            padding-right: 120px;
            padding-left: 120px;

        }

    }

</style>
